import { Box, Image, Button, Link } from '@chakra-ui/react';
import NextLink from 'next/link';

const ImageBlog = ({ big, title, blogPath, body, categoryName, categoryPath, created, image }) => {
  const newOrder1 = big ? '1' : '2';
  const newOrder2 = big ? '2' : '1';

  return (
    <Box paddingBottom="35px">
      <NextLink href={blogPath || '#'} passHref prefetch={false}>
        <Link title={title || categoryName}>
          {image && <Image src={image} w="100%" _hover={{}} alt={title || categoryName} />}
        </Link>
      </NextLink>
      <Box display="flex" flexDirection="column">
        <NextLink href={categoryPath || '#'} passHref prefetch={false}>
          <Link
            title={categoryName}
            fontWeight="600"
            fontSize="16px"
            lineHeight="20px"
            color={'brand.900'}
            padding="10px 0 5px 0"
          >
            {categoryName}
          </Link>
        </NextLink>
        {big ? (
          <NextLink href={blogPath || '#'} passHref prefetch={false}>
            <Link title={title || categoryName} fontSize="36px" lineHeight="45px" paddingBottom="30px">
              {title}
            </Link>
          </NextLink>
        ) : (
          <NextLink href={blogPath || '#'} passHref prefetch={false}>
            <Link
              title={title || categoryName}
              fontSize={{ base: '18px', lg: '20px', xl: '28px' }}
              lineHeight={{ base: '22px', lg: '25px', xl: '32px' }}
            >
              {title}
            </Link>
          </NextLink>
        )}

        <NextLink href={blogPath || '#'} passHref prefetch={false}>
          <Link title={title || categoryName} fontSize="20px" lineHeight="25px" paddingBottom="10px" order={newOrder2}>
            {body}
          </Link>
        </NextLink>
        {/* <Box fontSize="16px" lineHeight="20px" color={'text.secondary'} paddingBottom="10px" order={newOrder1}>
          {created}
        </Box> */}
      </Box>
      {big && (
        <NextLink href={blogPath || '#'} passHref prefetch={false}>
          <Button as={'a'} variant={'outline'} fontWeight="bold" fontSize="14px" lineHeight="18px" color="brand.900">
            Read & Shop
          </Button>
        </NextLink>
      )}
    </Box>
  );
};

export default ImageBlog;
